import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import { string } from 'prop-types';
import Alert from '../../../atoms/alert/alert';
import AlertIcon from '../../../../../resources/images/alert-triangle-red.svg';
import { PRODUCT_CHANGE_STATUS } from '../constants';

const ProductStatusChangeAlert = ({ status, className, unavailableAlertMsg, maxAvailableQty }) => {
    const intl = useIntl();

    const getMaxQtyExceedWarning = () => (
        <div>
            {intl.formatMessage({ id: 'common:max-available-qty' })} <strong>{maxAvailableQty}</strong>.
        </div>
    );

    const renderAlert = () => {
        switch (status) {
            case PRODUCT_CHANGE_STATUS.UNAVAILABLE:
                const unavailableMessage = unavailableAlertMsg || intl.formatMessage({ id: 'common:unavailable-for-your-rental' });
                return (
                    <Alert
                        message={unavailableMessage}
                        type="error"
                        icon={<AlertIcon tabIndex={-1} aria-hidden={true} />}
                        localStyle={className}
                        id={'alert-msg'}
                        role={'none'}
                        ariaLabel={unavailableMessage}
                    />
                );
            case PRODUCT_CHANGE_STATUS.MAX_QTY_EXCEED:
                return (
                    <Alert
                        message={getMaxQtyExceedWarning()}
                        type="warning"
                        icon={<AlertIcon tabIndex={-1} aria-hidden={true} />}
                        localStyle={className}
                        id={'warning-msg'}
                        role={'none'}
                        ariaLabel={`${intl.formatMessage({ id: 'common:max-available-qty' })} ${maxAvailableQty}.`}
                    />
                )
            default:
                return <></>;
        }
    };

    return renderAlert();
};

ProductStatusChangeAlert.propTypes = {
    status: string,
    className: string,
    unavailableAlertMsg: string
};

ProductStatusChangeAlert.defaultProps = {
    status: '',
    className: '',
    unavailableAlertMsg: ''
};

export default memo(ProductStatusChangeAlert);
